/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A bias test to run as part of an experiment
 * @export
 * @interface BiasTestRequest
 */
export interface BiasTestRequest {
    /**
     * 
     * @type {string}
     * @memberof BiasTestRequest
     */
    type: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof BiasTestRequest
     */
    params: { [key: string]: any; };
}

/**
 * Check if a given object implements the BiasTestRequest interface.
 */
export function instanceOfBiasTestRequest(value: object): value is BiasTestRequest {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('params' in value) || value['params'] === undefined) return false;
    return true;
}

export function BiasTestRequestFromJSON(json: any): BiasTestRequest {
    return BiasTestRequestFromJSONTyped(json, false);
}

export function BiasTestRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BiasTestRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'params': json['params'],
    };
}

export function BiasTestRequestToJSON(json: any): BiasTestRequest {
    return BiasTestRequestToJSONTyped(json, false);
}

export function BiasTestRequestToJSONTyped(value?: BiasTestRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'params': value['params'],
    };
}

